// removed by extract-text-webpack-plugin
module.exports = {"button":"TicketTypeButton__button__27kGu","title":"TicketTypeButton__title__3UWmV","active":"TicketTypeButton__active__3NX61","triangle":"TicketTypeButton__triangle__11sBF"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/TicketTypeButton/TicketTypeButton.css
// module id = 537
// module chunks = 0